export default "__VITE_ASSET__CxrrxMCA__"